<template>
    <div class="filled-content">
        <v-toolbar app flat dark color="primary">
            <v-btn small flat class="pa-0" @click="gotoOverview()">Annuleren</v-btn>
            <v-toolbar-title>Account</v-toolbar-title>
            <v-btn small flat class="pa-0" @click="gotoOverviewAndSave()">Opslaan</v-btn>
        </v-toolbar>

        <v-content class="uf-form" fill-height>
			<form @submit.prevent="save" ref="accountForm">
			<validation-observer ref="validationObserver">

				<v-container class="item-group">
					<div class="headline">
						{{ first_name }}
						{{ last_name_prefix }}
						{{ last_name }}
					</div>
					<div>{{ customer_number }} - {{ email }}</div>
				</v-container>

				<v-alert
					:value="!valid"
					type="error"
					outline
					class="ma-3"
				>
					Niet alle velden zijn correct ingevuld
				</v-alert>

				<v-subheader>Naam</v-subheader>
				<v-container class="item-group">
					<validation-provider name="Voorletters/Voornaam" rules="required" v-slot="{ errors }" slim>
						<v-text-field
								v-model="first_name"
								label="Voorletters/Voornaam"
								:error-messages="errors[0]"
								placeholder=" "
								required
						></v-text-field>
					</validation-provider>
					<v-text-field
							v-model="last_name_prefix"
							label="Tussenvoegsel"
							:error-messages="errors[0]"
							placeholder=" "
					></v-text-field>
					<validation-provider name="Achternaam" rules="required" v-slot="{ errors }" slim>
						<v-text-field
							v-model="last_name"
							label="Achternaam"
							:error-messages="errors[0]"
							placeholder=" "
							required
						></v-text-field>
					</validation-provider>
				</v-container>

				<v-subheader>Contact</v-subheader>
				<v-container class="item-group">
					<validation-provider name="Telefoonnummer" rules="required|phone" v-slot="{ errors }" slim>
						<v-text-field
							v-model="phone"
							:error-messages="errors[0]"
							mask="##-########"
							:rules="[(v) => v.length === 10 || 'Telefoonnummer moet bestaan uit 10 cijfers.']"
							label="Telefoon (mobiel) *"
							required
						></v-text-field>
					</validation-provider>
				</v-container>

				<v-subheader>Adres</v-subheader>
				<v-container class="item-group">
					<validation-provider name="Straat" rules="required" v-slot="{ errors }" slim>
						<v-text-field
							v-model="street"
							label="Straat"
							placeholder=" "
							:error-messages="errors[0]"
							required
						></v-text-field>
					</validation-provider>
					<validation-provider name="Straat" rules="required" v-slot="{ errors }" slim>
						<v-text-field
							v-model="house_number"
							label="Huisnummer"
							placeholder=" "
							:error-messages="errors[0]"
							required
						></v-text-field>
					</validation-provider>
					<validation-provider name="Postcode" rules="required" v-slot="{ errors }" slim>
						<v-text-field
							v-model="postcode"
							label="Postcode"
							placeholder=" "
							:error-messages="errors[0]"
							required
						></v-text-field>
					</validation-provider>
					<validation-provider name="Stad" rules="required" v-slot="{ errors }" slim>
						<v-text-field
							v-model="city"
							label="Stad"
							placeholder=" "
							:error-messages="errors[0]"
							required
						></v-text-field>
					</validation-provider>
					<validation-provider name="Land" rules="required" v-slot="{ errors }" slim>
						<v-select
							v-model="country"
							:items="countries"
							label="Land"
							placeholder=" "
							:error-messages="errors[0]"
							required
						>
						</v-select>
					</validation-provider>
				</v-container>

			</validation-observer>
            <!--
            <v-container>
                <v-btn block dark depressed flat large color="red">Account opzeggen</v-btn>
            </v-container>
            -->
			</form>
        </v-content>
    </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

const { mapFields } = createHelpers({
  getterType: 'getUserField',
  mutationType: 'updateUserField',
});

export default {
  components: { ValidationProvider, ValidationObserver },
  computed: {
    ...mapFields([
      'first_name',
      'last_name_prefix',
      'last_name',
      'email',
      'phone',
      'street',
      'house_number',
      'postcode',
      'city',
      'country',
      'customer_number',
    ]),
  },
  data() {
    return {
		valid: true,
		countries: [
			"Nederland",
			"Luxemburg",
			"België",
			"Duitsland",
			"Verenigd Koninkrijk",
		]
	}
  },
  created() {
    if(!this.country) this.country = "Nederland";
  },
  methods: {
    gotoOverview() {
	  this.$router.go(-1);
    },
    gotoOverviewAndSave() {
      this.save();
    },
	async save() {
      this.valid = await this.$refs.validationObserver.validate();
      if (!this.valid) return window.scrollTo(0, 0);

      this.$store.dispatch('updateUser').then(() => {
        this.$router.go(-1);
      });
	}
  },
};
</script>

<style lang="stylus">
    .uf-form
        background-color: #f2f2f2
        min-height: 100vh

        .item-group
            background-color: #fff
            border-top: solid 1px #ddd
            border-bottom: solid 1px #ddd
</style>
